var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 176",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cnib7k5q2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 485",
    style: {
      fill: "none"
    },
    d: "M0 0h21v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 175",
    style: {
      clipPath: "url(#cnib7k5q2a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 235",
    d: "M21.343 51.615A4.672 4.672 0 1 1 16.671 47a4.644 4.644 0 0 1 4.671 4.615",
    transform: "translate(-11.066 -43.385)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 236",
    d: "M34.523 161.1h.865l.435-.009c.409 0 .818 0 1.227.007a1.082 1.082 0 0 1 1.1 1.021 1.058 1.058 0 0 1-1.064 1.053h-.062c-.481.02-.471.01-.635.449a58.98 58.98 0 0 1-.666 1.676.8.8 0 0 1-.725.468.689.689 0 0 1-.666-.446c-.248-.58-.5-1.161-.718-1.752-.107-.292-.242-.456-.579-.394a1.135 1.135 0 0 1-1.161-1.023 1.055 1.055 0 0 1 1.056-1.054h.084c.4 0 .8 0 1.2-.007l.313.01",
    transform: "translate(-29.389 -148.696)",
    style: {
      fill: "#e64c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 237",
    d: "M56.411 112.112a.546.546 0 0 1-.549.535.567.567 0 0 1-.522-.533.552.552 0 0 1 .553-.5.535.535 0 0 1 .518.5",
    transform: "translate(-51.031 -103.031)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 238",
    d: "M56.347 138.947a.479.479 0 0 1-.457.5.491.491 0 0 1-.057 0 .516.516 0 1 1-.006-1.031h.032a.479.479 0 0 1 .487.529",
    transform: "translate(-51.002 -127.769)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 239",
    d: "M32.723 125.119a.473.473 0 0 1-.415.527.484.484 0 0 1-.065 0 .515.515 0 0 1 0-1.03.462.462 0 0 1 .48.443.453.453 0 0 1 0 .057",
    transform: "translate(-29.266 -115.033)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 240",
    d: "m86.831 98-.534-.406-.487-.505a4.182 4.182 0 0 1-.906-2.3c-.017-.581-.007-1.163-.006-1.745a.793.793 0 0 1 .669-.835 4.4 4.4 0 0 1 .608-.043h.872c.693 0 1.386.007 2.079.008h3.911a.848.848 0 0 0 .9-.6c.2-.529.384-1.063.571-1.6.091-.26.135-.284.533-.238l.99.357.209.1c-.084.249-.162.5-.252.747-.493 1.347-.972 2.7-1.489 4.038a4.241 4.241 0 0 1-3.14 2.739c-.623.147-1.253.267-1.877.408a4.344 4.344 0 0 1-2.461-.11.638.638 0 0 0-.19-.015m3.462-4.4h-3.522c-.23 0-.41.115-.422.3a4.058 4.058 0 0 0 0 .873 2.851 2.851 0 0 0 1.14 1.927 2.779 2.779 0 0 0 2.152.53c.505-.081 1-.2 1.506-.3a4.053 4.053 0 0 0 1.618-.665 3.95 3.95 0 0 0 1.435-2.033c.14-.429-.006-.638-.466-.638h-3.44",
    transform: "translate(-78.284 -82.811)",
    style: {
      fill: "#4fba6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 241",
    d: "M109.781 103.659a.642.642 0 0 1 .185.008 4.345 4.345 0 0 0 2.461.11c.624-.142 1.254-.261 1.877-.408a4.241 4.241 0 0 0 3.14-2.739c.517-1.338 1-2.691 1.49-4.038.09-.247.168-.5.252-.747l.523.162c.341.17.346.185.214.542-.571 1.544-1.125 3.093-1.716 4.629a4.2 4.2 0 0 1-2.274 2.375 9.42 9.42 0 0 1-1.876.506c-.4.091-.81.162-1.213.25a3.841 3.841 0 0 1-2.136-.187 8.12 8.12 0 0 1-.926-.464",
    transform: "translate(-101.234 -88.472)",
    style: {
      fill: "#24ae5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 242",
    d: "m216.157 7.277-.99-.357c.1-.314.2-.631.312-.941.359-.985.725-1.967 1.089-2.95.355-.957.713-1.914 1.063-2.873.054-.149.129-.189.277-.13.253.1.51.193.765.289-.026.091-.045.183-.077.272q-.569 1.553-1.14 3.105c-.3.819-.609 1.636-.909 2.455-.137.374-.261.753-.391 1.129",
    transform: "translate(-198.415)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 243",
    d: "M227.88 11.062c.13-.377.254-.755.391-1.129.3-.82.607-1.637.909-2.455q.572-1.552 1.14-3.105c.032-.088.052-.181.077-.272.207.068.416.13.619.207.124.047.145.151.1.271l-1.473 3.983-.9 2.441c-.04.108-.088.212-.133.318l-.523-.162-.209-.1",
    transform: "translate(-210.138 -3.786)",
    style: {
      fill: "#d5d4e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 244",
    d: "M107.261 140.172h3.44c.46 0 .606.208.466.638a3.95 3.95 0 0 1-1.434 2.032 4.052 4.052 0 0 1-1.618.665c-.5.1-1 .223-1.506.3a2.779 2.779 0 0 1-2.152-.53 2.851 2.851 0 0 1-1.137-1.932 4.058 4.058 0 0 1 0-.874c.012-.188.191-.3.422-.3h3.522",
    transform: "translate(-95.252 -129.389)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 245",
    d: "M16.367 224.923H.684a.68.68 0 0 1-.684-.676v-1.572A.68.68 0 0 1 .684 222h15.683a.68.68 0 0 1 .684.676v1.572a.68.68 0 0 1-.684.676",
    transform: "translate(0 -204.923)",
    style: {
      fill: "#0d90db"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.0534d503999e90d83f6f71ebac14a264.svg";
export { ForwardRef as ReactComponent };